import { shareReplay, Observable, map, filter } from 'rxjs';
import { SituationService } from 'src/app/service/situation.service';
import { AuthService } from './../service/auth.service';
import { Component, ElementRef, Inject, OnInit, isDevMode } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { DOCUMENT, Location } from '@angular/common';
import { CLO013 } from '../interface/clo013';
import { BreakpointObserver, Breakpoints, MediaMatcher } from '@angular/cdk/layout';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  clo013: Observable<CLO013>;
  lang: string;

  outterLinkActive: any;

  openHead: boolean;

  header: any[];
  // currentScreenSize: string;
  showWarning: Observable<boolean>;


  isMediumScreen: Observable<any>;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private location: Location,
    @Inject(DOCUMENT) private document: Document, private translate: TranslateService,
    private authService: AuthService, private router: Router,
    private sir: SituationService) {

    this.isMediumScreen = breakpointObserver.observe("(max-width: 1023px)").pipe(map(a => a.matches));

    this.openHead = false;
    // console.log('(max-width: 1023px)', this.openHead);
    this.clo013 = this.sir.getCLO013().pipe(map(a => a[0]), shareReplay());
    this.clo013.subscribe(data => {
      authService.authState$
      .pipe(
        filter(a => a != null)
      )
      .subscribe(a => {
/*
        if(isDevMode()) {
          console.log('dev mode');
          authService.insertLoginRecord(data.teacH_GRP_NAME, data.stno, data.cH_NAME).subscribe(data2 => {
            console.log(data2);
         });
        }
        else{
          if(a.email.toLowerCase().endsWith('@tmu.edu.tw')){
            authService.insertLoginRecord(data.teacH_GRP_NAME, data.stno, data.cH_NAME).subscribe(data2 => {
              console.log(data2);
           });
          }
        }
*/
authService.insertLoginRecord(data.teacH_GRP_NAME, data.stno, data.cH_NAME);
authService.getStudentBadges(data.stno);

      })
    });
    this.lang = 'tw';

    //3.學制=碩士班M、碩士在職專班G、產碩專班I、博士班D，不呈現"學習預警" "學期排名"
    this.showWarning = this.sir.isGraduate().pipe(map(a => !a.graduate));

    translate.addLangs(['tw', 'en']);
    translate.setDefaultLang(this.lang);

    this.header = [
      {
        title: '個人常用功能',
        routelink: ['/short-cut']
      },
      {
        title: 'Today',
        routelink: ['/today']
      },
      {
        title: '修業狀況',
        routelink: ['/situation'],
        child: [
          {
            title: '畢業資格',
            routelink: ['/', 'situation']
          },
          {
            title: '學期排名',
            routelink: ['/', 'situation', 'CLO032'],
            show: this.showWarning
          },
          {
            title: '學習預警',
            routelink: ['/', 'situation', 'warning'],
            show: this.showWarning
          },
        ]
      },
      {
        title: '學習發展',
        child: [
          {
            title: 'EMI學習',
            routelink: ['/grow', 'emi']
          },
          {
            title: '重點領域',
            routelink: ['/grow', 'point']
          },
          {
            title: '見/實習',
            routelink: ['/grow', 'CLO001']
          },
          {
            title: '選課積木池',
            routelink: ['/grow', 'favorite']
          }
        ]
      },
      {
        title: '課外學習',
        child: [
          {
            title: '領導知能',
            routelink: ['/after-school']
          },
          {
            title: '課外學習',
            routelink: ['/after-school', 'service']
          }
        ]
      },
      {
        title: '能力指標',
        routelink: ['/ability'],
        child: [
          {
            title: '專業',
            routelink: ['/ability'],
            fragment: 'chart_0'
          },
          {
            title: '必修',
            routelink: ['/ability'],
            fragment: 'chart_1'
          },
          {
            title: '選修',
            routelink: ['/ability'],
            fragment: 'chart_2'
          },
          {
            title: '次選單-通識',
            routelink: ['/ability'],
            fragment: 'chart_3'
          },
          {
            title: '跨域',
            routelink: ['/ability'],
            fragment: 'chart_4'
          },
          {
            title: '12項就業能力',
            routelink: ['/ability'],
            fragment: 'chart_5'
          }
        ]
      },
      {
        title: '個人專屬雲',
        child: [
          {
            title: '個人履歷',
            routelink: ['/personal']
          },
          {
            title: '操行成績',
            routelink: ['/personal', 'conduct']
          }
        ]
      },
      {
        title: '資源連結',
        child: [
          {
            title: '資源連結',
            routelink: ['/resource']
          }
        ]
      },
      {
        title: '成就名人堂',
        routelink: ['/achievement']
      }

    ];
  }

  changeLang(lang: string) {
    this.translate.use(lang).subscribe(a => {
      // console.log(a)
      this.lang = lang;


      this.document.querySelectorAll('link[data-lang]').forEach(a => {
        if (this.lang == 'en') {
          (a as HTMLElement).setAttribute('href', `css/${a.getAttribute('data-lang')}-EN.css`);
        }
        else {
          (a as HTMLElement).setAttribute('href', `css/${a.getAttribute('data-lang')}.css`);
        }
      })

    })
  }

  ngOnInit(): void {
  }

  goBack() {
    this.location.back();
  }

  openHeadMethod(open?: boolean) {
    this.openHead = (open == undefined) ? !this.openHead : open;
    const body = this.document.querySelector('body') as HTMLElement;

    if (this.openHead && !body.classList.contains('body__full')) {
      body.classList.add('body__full')
    } else if (this.openHead == false && body.classList.contains('body__full')) {
      body.classList.remove('body__full');
    }


  }



  async logout() {
    await this.authService.signOut();
    this.router.navigateByUrl('/login');
  }



}
